import React from 'react';
import { Dialog, DialogTitle } from '@mui/material';
import { t } from 'i18next';
import DateItem from './CalendarTabs/monthView/DateItem';

export default function CalendarMoreEvents({
  data,
  setOpen,
  setSelected,
  open,
  refetchFn = () => {},
}) {
  const onClose = () => setOpen(null);
  const onClick = (data) => setSelected(data);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      className='!z-[10000]'
      PaperProps={{ className: '!base-border !shadow-none !overflow-hidden' }}
    >
      <DialogTitle
        id='alert-dialog-title'
        className='!bg-[#CDCDCDC7] !text-center !border-b !border-b-[#E6E6E6]'
      >
        <span className='pr-5 font-semibold text-[21px] text-[#374957]'>
          {t('tasks.title')}
        </span>
      </DialogTitle>
      <div className='cursor-pointer py-4 px-8 min-w-[600px] max-h-[540px] overflow-y-auto my-scroll'>
        {data?.map((d, i) => (
          <div
            key={i}
            onClick={() => onClick(d)}
            className='rounded-md my-0.5 overflow-hidden text-white [&>*]:p-1'
          >
            <DateItem data={d} />
          </div>
        ))}
      </div>
    </Dialog>
  );
}
